/**
 * @file AdUnitColumnSlot.tsx
 *
 * @fileoverview Renders column ad unit.
 *  This ad banner is rendered as a column that is part of the MultiColImageText.
 */
interface AdUnitColumnSlotProps {
  bundle?: string;
  adUnitId?: string;
}

export default function AdUnitColumnSlot({
  bundle,
  adUnitId,
}: AdUnitColumnSlotProps) {
  return <></>;
}

export { AdUnitColumnSlot };
